import React from 'react';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import 'react-select/dist/react-select.css';
import 'react-datepicker/dist/react-datepicker.css';
import nl2br from 'react-nl2br';
import {showCategory} from './utils';
import PreviewImagesBlock from './PreviewImagesBlock';
import Map from '../Map/Map';
import {Button} from "../../../../components/Button";
import DaysTable from '../TourDates'

class Tmp1 extends React.Component {

  static propTypes = {
    id: PropTypes.number,
    title: PropTypes.string,
    minPersons: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    maxPersons: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    // priceOnePerson: PropTypes.oneOfType([
    //   PropTypes.string,
    //   PropTypes.number,
    // ]),
    description: PropTypes.string,
    tourPhotos: PropTypes.array,
    categoryId: PropTypes.number,
    cityId: PropTypes.number,
    address: PropTypes.string,
    lat: PropTypes.number,
    lng: PropTypes.number,
    tourVideos: PropTypes.array,
    showPlayer: PropTypes.func,
    categories: PropTypes.array,
    tourDates: PropTypes.array,
    addToCart: PropTypes.func,
    deleteFromCart: PropTypes.func,
    isInCart: PropTypes.bool,
    cartError: PropTypes.object,
    user: PropTypes.object,
  };

  render() {
    const {
      id,
      title,
      minPersons,
      maxPersons,
      // priceOnePerson,
      description,
      tourPhotos,
      categoryId,
      cityId,
      address,
      tourVideos,
      lat,
      lng,
      showPlayer,
      categories,
      tourDates,
      addToCart,
      deleteFromCart,
      isInCart,
      cartError,
      user,
    } = this.props;

    return (
      <div className="tour-page__template template1">
        <h2 className="tour-page__name">{title}</h2>
        <div className="tour-page__header">
          <div className="tour-page__info">
            <div className="tour-page__info-block">
              <span className="tour-page__info-label">Category:</span>
              {showCategory(categories, categoryId)}
            </div>
            <div className="tour-page__info-block">
              <span className="tour-page__info-label">People amount:</span>
              <span className="tour-page__info-content">{minPersons} - {maxPersons}</span>
            </div>
            {/* <div className="tour-page__info-block tour-page__price"> */}
            {/* <span className="tour-page__info-label">Price:</span> */}
            {/* <span className="tour-page__info-content">$ {priceOnePerson} <span>/person</span></span> */}
            {/* </div> */}
          </div>
          {
            user && !user.isAdmin && user.vendorType !== 'tour' ?
              (
                <div className="tour-page__buttons">
                  {
                    isInCart ?
                      <Button
                        className="button__drop"
                        name="Delete from cart"
                        onClick={() => {
                          deleteFromCart(id)
                        }}
                      /> :
                      <Button
                        name="Book now"
                        onClick={() => {
                          addToCart(id, cityId)
                        }}
                      />
                  }
                  {cartError.differentCity && <span className="error-block">{cartError.differentCity}</span>}
                </div>
              ) : null
          }
        </div>
        <div className="tour-page__description">
          <h3 className="tour-page__title">Description:</h3>
          <p className="tour-page__description-body">{nl2br(description)}</p>
        </div>
        <PreviewImagesBlock
          images={tourPhotos}
        />
        <div className="tour-page__map">
          <h3 className="tour-page__title">Address</h3>
          <div className="tour-page__map-address">
            <span>{address}</span>
          </div>
          <Map
            cords={{lat, lng}}
            zoom={8}
          />
        </div>
        {
          tourVideos && tourVideos[0] && tourVideos[0].active ?
            <div className="tour-page__video">
              <div className="tour-page__video-overlay">
                <Button
                  className="button__icon fa fa-play"
                  onClick={() => showPlayer(tourVideos[0])}
                />
              </div>

              <img
                src={tourVideos[0].thumbnailUrl}
                alt="video"
              />
            </div> : null
        }
        <DaysTable
          tourDates={tourDates}
        />
        {
          user && !user.isAdmin && user.vendorType !== 'tour' ?
            (
              <div className="tour-page__buttons">
                {cartError.differentCity && <span className="error-block">{cartError.differentCity}</span>}
                {
                  isInCart ?
                    <Button
                      className="button__drop"
                      name="Delete from cart"
                      onClick={() => {
                        deleteFromCart(id)
                      }}
                    /> :
                    <Button
                      name="Book now"
                      onClick={() => {
                        addToCart(id, cityId)
                      }}
                    />
                }
              </div>
            ) : null
        }
      </div>
    )
  }
}

export default withRouter(Tmp1);


// WEBPACK FOOTER //
// ./src/app/containers/TourPage/components/Templates/Tmp1.js